import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {BaseComponent, CartProduct, formatPriceNumber, ProductCustomer} from 'compob2b-libs'

import {NbTooltipModule} from '@nebular/theme'
import {AuthService} from 'compob2b-auth'
import {TuiIcon} from '@taiga-ui/core'

@Component({
  selector: 'app-product-price',
  providers: [formatPriceNumber],
  imports: [
    NbTooltipModule,
    TuiIcon
  ],
  templateUrl: './product-price.component.html',
  styleUrl: './../product-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductPriceComponent extends BaseComponent {
  @Input() amount: number = 1
  @Input() product: ProductCustomer | CartProduct
  @Input() showDetails = false;

  authService = inject(AuthService);
  formatPriceNumber = inject(formatPriceNumber);

  get discount() {
    if (!this.environment.showDiscountPanel) {
      return 0;
    }

    const commercePrice = this.product?.discountPrice || this.product.commercePrice?.price;
    const basePrice = this.product.price;

    return Math.round((basePrice - commercePrice) / basePrice * 100);
  }

  get discountPrice() {
    return this.product?.discountPrice && !this.product.discountCostOnlyTotal ? this.product.discountPrice : 0
  }

  get commercePrice() {
    return this.product.commercePrice?.price || 0;
  }

  formatPrice(price) {
    if (this.showDetails) {
      return this.formatPriceNumber.transform(price) + ' ₽';
    }
    return price;
  }
}
